import { useMutation, useQuery } from '@tanstack/react-query';
import { createRate, deleteRate, getRate, getRates, restoreRate, updateRate } from '@/features/agreements/services/ratesService';

const BASE = 'rates';

export const ratesQueryKeys = {
  base: () => [BASE],
  list: ({ agreementId, planId, filters } = {}) => agreementId && planId ? [BASE, 'list', agreementId, planId, filters] : [BASE, 'list'],
  detail: ({ agreementId, planId, rateId } = {}) => agreementId && planId && rateId ? [BASE, 'detail', agreementId, planId, rateId] : [BASE, 'detail'],
};

export const useGetRates = ({ agreementId, planId, filters }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: ratesQueryKeys.list({ agreementId, planId, filters }),
    queryFn: () => getRates(agreementId, planId, filters),
    enabled: enabled && !!agreementId && !!planId,
  });
};

export const useGetRate = ({ agreementId, planId, rateId }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: ratesQueryKeys.detail({ agreementId, planId, rateId }),
    queryFn: () => getRate(agreementId, planId, rateId),
    enabled: enabled && !!agreementId && !!planId && !!rateId,
  });
};

export const useCreateRate = () => {
  return useMutation({
    mutationFn: ({ agreementId, planId, data }) => createRate(agreementId, planId, data),
  });
};

export const useUpdateRate = () => {
  return useMutation({
    mutationFn: ({ agreementId, planId, rateId, data }) => updateRate(agreementId, planId, rateId, data),
  });
};

export const useDeleteRate = () => {
  return useMutation({
    mutationFn: ({ agreementId, planId, rateId }) => deleteRate(agreementId, planId, rateId),
  });
};

export const useRestoreRate = () => {
  return useMutation({
    mutationFn: ({ agreementId, planId, rateId }) => restoreRate(agreementId, planId, rateId),
  });
};
